import axios from 'axios';

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': "application/json" },
});

const socket_server = axios.create({
    baseURL: process.env.REACT_APP_SOCKET_URL,
    headers: { 'Content-Type': "application/json" },
});


export class DiscountPosFetchAPI {
    static async createTempDiscount(data, token) {
        const res = await server(`/temp/order`, {
            method: "post",
            data: data,
            headers: {'x-access-token': token},
        });
        return res
    }

    static async getTempDiscount(machine_code, bussiness_code, branchoffice_code, token) {
        const res = await server(`/temp/machine/order/${machine_code}/${bussiness_code}/${branchoffice_code}/true`, {
            method: "get",
            headers: {'x-access-token': token},

        });
        return res
    }

    static async updateOrderTemp(data, token) {
        const res = await server(`/temp/order`, {
            method: "delete",
            data: data,
            headers: {'x-access-token': token},

        });
        return res
    }
}